<template>
  <div class="step step--climate-control step-climate-control">
    <div class="step-climate-control__container">
      <div class="step-climate-control__title text-shadow" v-html="$t('climateControl.title')"></div>

      <div class="step-climate-control__text" v-html="$t('climateControl.title2')"></div>

      <div class="conditioning__controls step-climate-control__controls">
        <div class="conditioning__image step-climate-control__image">
          <img src="@/assets/img/climate-control-ac.png" alt="stylish condition">
        </div>

        <div class="conditioning__control step-climate-control__control">
          <img class="image-rendering-contrast" src="@/assets/img/modes/climate.png" alt="humidity mode">
        </div>
      </div>

      <div class="step-climate-control__actions">
        <div class="step-climate-control__actions-text">
          <p v-html="$t('climateControl.button')"></p>
        </div>
        <div class="step-climate-control__actions-toggler">
          <Toggler @change="toggleChange"></Toggler>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toggler from '../global/Toggler'

export default {
  name: 'StepClimateControl',
  components: {
    Toggler,
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  methods: {
    toggleChange (value) {
      if (value) {
        setTimeout(() => {
          this.$store.commit('setModel', 8)
          this.$store.commit('setClouds', 5)

          if (this.$gtm) {
            this.$gtm.trackEvent({
              'event': 'Event',
              'analytics_action': this.$store.state.step + '-button-switcher',
              'analytics_label': this.$store.state.step,
            })
          }

          this.$emit('next')
        }, 1000)
      }
    },
  },
}
</script>

<style scoped>

</style>
